import { MERCHANT } from "constants/action-types";
import { Observable } from "rxjs";
import { ActionsObservable } from "redux-observable";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import {
    GetMerchantPreferenceRequestAction,
    getMerchantPreferenceComplete,
} from "actions/merchant/merchant-preference";
import { formatMessage } from "lib/globalize-util";

export const getMerchantPreferenceEpic = (action$: ActionsObservable<GetMerchantPreferenceRequestAction>) =>
    action$
        .ofType(MERCHANT.PREFERENCE.GET.REQUEST)
        .map(({ payload }) => payload)
        .switchMap(({ merchantId }) => {
            return ajax(`${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/preference`)
                .flatMap(({ response, status }) => {
                    if (status !== 200) {
                        throw new Error(response.message || formatMessage("Unknown fetch error"));
                    }
                    return [getMerchantPreferenceComplete(response)];
                })
                .catch((error) => Observable.merge(Observable.of(getMerchantPreferenceComplete(error))));
        });
